export const roundOf = (value, decimals = 100) => Math.round(decimals * value) / decimals;
export const calculateCosts = (productData, estimation, vat, autoDiscounts, prices) => {
    const costs = {
        estimationCost: 0,
        fixedCost: 0,
        kwhCost: 0,
        vat: vat,
        kwhVat: 0,
    };
    if (prices)
        costs.kwhCost = prices.purchase / 100 + prices.elCertificate / 100;
    productData.forEach((data) => {
        data.types?.forEach((type) => {
            readTypes(type, costs);
            if (type.name.toLowerCase() == "påslag") {
                costs.surcharge = convertCosts(type);
            }
        });
    });
    costs.kwhCost = roundOf(costs.kwhCost * 100, 100000) / 100;
    costs.kwhVat = roundOf(costs.kwhCost * (vat / 100), 100000);
    costs.estimationCost = Math.round((costs.fixedCost + costs.kwhCost * (estimation / 12)) * (vat / 100 + 1));
    if (autoDiscounts && autoDiscounts.length) {
        const discount = {
            kwhCost: costs.kwhCost,
            fixedCost: costs.fixedCost,
            kwhVat: 0,
            kwhLength: 0,
            fixedLength: 0,
            estimationCost: 0,
        };
        autoDiscounts.forEach((autoDiscount) => {
            readDiscount(autoDiscount, discount);
        });
        discount.estimationCost = Math.round((discount.fixedCost + discount.kwhCost * (estimation / 12)) * (vat / 100 + 1));
        discount.kwhVat = roundOf(discount.kwhCost * (vat / 100), 100000);
        costs.discount = discount;
    }
    return costs;
};
const parseAddon = (linkedAddon, vat) => {
    const costs = { fixedCost: 0, kwhCost: 0 };
    linkedAddon.data.forEach((data) => {
        data.types?.forEach((type) => {
            readTypes(type, costs);
        });
    });
    if (costs.kwhCost) {
        costs.kwhCost =
            roundOf(costs.kwhCost * 100, 100) + roundOf(costs.kwhCost * 100 * (vat / 100), 100);
    }
    return {
        id: linkedAddon.id,
        description: linkedAddon.description,
        costs: costs,
        name: linkedAddon.name,
        mandatory: linkedAddon.mandatory,
        preSelected: linkedAddon.preselected,
    };
};
export const getFixedProducts = (products, estimation, data) => {
    let vat = data.productPrices.vat;
    let fixedProducts = [];
    products.products.forEach((product) => {
        let fixedProduct = {
            id: product.id,
            name: product.name,
            length: product.length / 12,
            costs: undefined,
            type: "fixed",
            typeId: product.typeId,
            offerId: data.offer.id,
            startDates: data.offer.startDates == null ? undefined : data.offer.startDates,
            addons: [],
            bankID: data.offer.signWithBankID === true,
            recommended: product.recommended,
            purchaseText: product.purchaseText,
            priceComparison: product.priceComparison ? product.priceComparison : undefined,
        };
        product.data &&
            (fixedProduct.costs = calculateCosts(product.data, estimation, vat, product.autoDiscounts));
        if (product.linkedAddons) {
            product.linkedAddons.forEach((a) => {
                fixedProduct.addons.push(parseAddon(a, vat));
            });
        }
        fixedProducts.push(fixedProduct);
    });
    return fixedProducts;
};
export const getVariableProducts = (products, data, estimation) => {
    let price = data.productPrices;
    let variableProducts = [];
    products.forEach((product) => {
        product.products.forEach((product) => {
            let variableProduct = {
                id: product.id,
                typeId: product.typeId,
                name: product.name,
                type: product.hourly || product.typeKey == "timpris" ? "hourly" : "variable",
                length: 0,
                costs: undefined,
                startDates: data.offer.startDates == null ? undefined : data.offer.startDates,
                offerId: data.offer.id,
                addons: [],
                bankID: data.offer.signWithBankID === true,
                recommended: product.recommended,
                purchaseText: product.purchaseText,
                skipDateFrom: product.skipDateFrom,
                previousMonth: new Date(data.productPrices.purchaseStartDate),
                priceComparison: product.priceComparison ? product.priceComparison : undefined,
            };
            if (product.linkedAddons) {
                product.linkedAddons.forEach((a) => {
                    variableProduct.addons.push(parseAddon(a, data.productPrices.vat));
                });
            }
            variableProduct.costs = product.data
                ? calculateCosts(product.data, estimation, price.vat, product.autoDiscounts, price)
                : undefined;
            variableProducts.push(variableProduct);
        });
    });
    return {
        variableProducts: variableProducts.filter((product) => product.type == "variable"),
        hourlyProducts: variableProducts.filter((product) => product.type == "hourly"),
    };
};
export const readDiscount = (type, discount) => {
    switch (type.entity.toLowerCase()) {
        case "öre/kwh":
            discount.kwhLength = type.length / 10;
            break;
        case "kr/kwh":
            discount.kwhLength = type.length / 10;
            break;
        case "kr/mån":
            discount.fixedLength = type.length / 10;
            break;
        case "kr/år":
            discount.fixedLength = type.length / 10;
            break;
    }
    return readTypes(type, discount);
};
export const readTypes = (type, costs) => {
    switch (type.entity.toLowerCase()) {
        case "öre/kwh":
            //Löpande avgift kWh * ([öre/kWh] * 10) = kr/mån
            costs.kwhCost += type.value / 100;
            break;
        case "kr/kwh":
            //Löpande avgift kWh * [kr/kWh] = kr/mån
            costs.kwhCost += type.value;
            break;
        case "kr/mån":
            //Månadsavgift kr/mån
            costs.fixedCost += type.value;
            break;
        case "kr/år":
            //Årsavgift kr/år / 12 = kr/mån
            costs.fixedCost += type.value / 12;
            break;
    }
};
export const getProductPrices = (data, estimation) => {
    const result = {};
    const group = data.offerProducts.productGroups.find((g) => g.key === "basprodukt");
    if (!group)
        return result;
    const fixedProductType = group.types.find((type) => type.key == "fast");
    const variableProductTypes = group.types.filter((type) => type.key == "rorligt");
    const hourlyProductTypes = group.types.filter((type) => type.key == "timpris");
    if (fixedProductType)
        result.fixedProducts = getFixedProducts(fixedProductType, estimation, data);
    if (variableProductTypes.length > 0) {
        const products = getVariableProducts(variableProductTypes, data, estimation);
        if (products.variableProducts.length > 0)
            result.variableProducts = products.variableProducts;
        if (products.hourlyProducts.length > 0)
            result.hourlyProducts = products.hourlyProducts;
    }
    if (hourlyProductTypes.length > 0) {
        const products = getVariableProducts(hourlyProductTypes, data, estimation);
        result.hourlyProducts = products.hourlyProducts;
    }
    return result;
};
export const getProductWithId = (id, data) => {
    const { variableProducts, fixedProducts, hourlyProducts } = data;
    if (variableProducts && variableProducts.find((p) => p.id == id)) {
        return variableProducts.find((p) => p.id == id);
    }
    else if (fixedProducts && fixedProducts.find((p) => p.id == id)) {
        return fixedProducts.find((p) => p.id == id);
    }
    else if (hourlyProducts && hourlyProducts.find((p) => p.id == id)) {
        return hourlyProducts.find((p) => p.id == id);
    }
};
export const convertCosts = (type) => {
    switch (type.entity.toLowerCase()) {
        case "öre/kwh":
            //Löpande avgift kWh * ([öre/kWh] * 10) = kr/mån
            return type.value / 100;
        case "kr/kwh":
            //Löpande avgift kWh * [kr/kWh] = kr/mån
            return type.value;
        case "kr/mån":
            //Månadsavgift kr/mån
            return type.value;
        case "kr/år":
            //Årsavgift kr/år / 12 = kr/mån
            return type.value / 12;
    }
};
export const getMicroDiscounts = (data, microIdWithTaxCode, microIdNoTaxCode) => {
    const products = data.result.offerProducts.productGroups
        .flatMap((group) => group.types)
        .flatMap((type) => type.products);
    const withTaxDiscount = products.find((p) => p.id == microIdWithTaxCode)?.autoDiscounts?.[0];
    const noTaxDiscount = products.find((p) => p.id == microIdNoTaxCode)?.autoDiscounts?.[0];
    const referenceLength = withTaxDiscount?.length ?? noTaxDiscount?.length ?? 0;
    const vatFactor = 1 + data.result.productPrices.vat / 100;
    return {
        microDiscountWithTaxId: withTaxDiscount ? -withTaxDiscount.value * vatFactor : 0,
        microDiscountNoTaxId: noTaxDiscount ? -noTaxDiscount.value : 0,
        dealLength: referenceLength > 12 ? referenceLength / 12 : referenceLength,
        lengthType: referenceLength > 12 ? "år" : "månader",
    };
};
